<button
  id="btn_close"
  type="button"
  (click)="close()"
  class="rounded-md px-3 py-2 text-md font-semibold text-gray-200 shadow-sm hover:bg-bv-darkblue-900"
>
  {{ label ? label : ("CLOSE" | translate) }}
</button>
